import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Text = makeShortcode("Text");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <Text sx={{
      fontSize: [4, 5, 6],
      fontWeight: `bold`,
      color: `heading`
    }} mdxType="Text">
  Hi. 안녕하세요.
    </Text>
    <p>{`Recently published fundamental `}<a parentName="p" {...{
        "href": "https://cloudacode.github.io/tutorials/"
      }}>{`hands-on tutorials`}</a>{` for cloud, devops and `}<a parentName="p" {...{
        "href": "https://cloudacode.github.io/hello-kubernetes/"
      }}>{`kubernetes`}</a>{`.
Most tutorials will step you through the process of building various applications on the cloud environment and improving development procedures with DevOps culture.`}</p>
    <p>{`클라우드, 데브옵스, 그리고 `}<a parentName="p" {...{
        "href": "https://cloudacode.github.io/hello-kubernetes/"
      }}>{`쿠버네티스`}</a>{`에 관련해 `}<a parentName="p" {...{
        "href": "https://cloudacode.github.io/tutorials/"
      }}>{`핸즈온 튜토리얼`}</a>{`을 제공 하고 있습니다. 클라우드 위에 다양한 애플리케이션을 구성하는 방법과 개발 및 운영 환경에 데브옵스 문화를 적용하여 서비스가 한 단계 더 발전해 나갈 수 있도록 실질적인 튜토리얼을 제공합니다.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      